import React, { FC } from 'react';

import styled from '@emotion/styled';

import { LucidThemeType } from '../../../types/types';

interface FieldsetProps extends LucidThemeType.OptionalProps {
  /** Allows the component to get additional styles. */
  className?: string;
  /** Checks if the fieldset is a real group. */
  isRealFieldset: boolean;
}

const StyledFieldset = styled.fieldset<FieldsetProps>(({ theme, isRealFieldset }) => [
  {
    label: 'fieldset',
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    border: 'none',
    padding: 0,
    margin: 0,
  },
  isRealFieldset && { marginBottom: theme.space.s32 },
]);

const Fieldset: FC<FieldsetProps> = rest => <StyledFieldset {...rest} />;

export default Fieldset;
